import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

/**
 * 모달 슬라이스 상태 타입
 */
export interface OriginalsTransitionState {
  isActive: boolean;
  linkUrl: string;
  title: string;
  description: string;
  fromIcon: string;
  toIcon: string;
}

export type OriginalsTransitionPayload = {
  linkUrl: string;
  title: string;
  description: string;
  fromIcon: string;
  toIcon: string;
};

/**
 * 모달 슬라이스 초기 상태
 * @type {isActive} - 활성 상태
 */
const initialState: OriginalsTransitionState = {
  isActive: false,
  linkUrl: '',
  title: '',
  description: '',
  fromIcon: '',
  toIcon: '',
};

const originalsTransitionSlice = createSlice({
  name: 'originalsTransition',
  initialState,
  reducers: {
    transitionStart(state, action: PayloadAction<OriginalsTransitionPayload>) {
      state.isActive = true;
      state.linkUrl = action.payload.linkUrl;
      state.title = action.payload.title ?? '';
      state.description = action.payload.description ?? '';
      state.fromIcon = action.payload.fromIcon ?? '';
      state.toIcon = action.payload.toIcon ?? '';
    },
    transitionEnd() {
      return initialState;
    },
  },
});

export const originalsTransitionActions = originalsTransitionSlice.actions;

export default originalsTransitionSlice;
